<template>
  <b-modal @ok="changeWebinarTime" ref="editChangeTime" id="editChangeTime" title="Перенести вебинар">
    <validation-observer
        v-slot="{ handleSubmit }"
        ref="refFormObserver"
    >
      <b-form
          ref="form"
          @submit.stop.prevent="handleSubmit(changeWebinarTime($event))"
          class="form validate"
      >
        <validation-provider
            v-slot="validationContext"
            name="date"
            :rules="{required: true}"
        >
          <b-form-group
              :label="$t('Дата проведения урока')"
              label-for="date"

          >
            <b-form-input
                type="date"
                placeholder="Введите тему вопроса"
                id="date"
                :state="getValidationState(validationContext)"
                v-model="form.scheduled_date"
                trim
            />
            <b-form-invalid-feedback>
              Заполните данное поле
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>

        <validation-provider
            v-slot="validationContext"
            name="time"
            :rules="{required: true}"
        >
          <b-form-group
              :label="$t('Время проведения урока')"
              label-for="time"
          >
            <b-form-input
                type="time"
                id="time"
                :state="getValidationState(validationContext)"
                v-model="form.scheduled_time"
                trim
            />
            <b-form-invalid-feedback>
              Заполните данное поле
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
      </b-form>
    </validation-observer>
  </b-modal>
</template>

<script>
import {BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BModal} from 'bootstrap-vue';
import {ValidationObserver, ValidationProvider} from 'vee-validate'
import validationMixin from "@/mixins/getValidationStateMixin";
import {createNamespacedHelpers} from 'vuex'

const {mapActions, mapState} = createNamespacedHelpers('teacher')

export default {
  props: {
    webinar: Object,
  },
  data() {
    return {
      form: {
        scheduled_date: '',
        scheduled_time: '',
      }
    }
  },
  mixins: [validationMixin],
  name: "changeWebinarTime",
  components: {
    BModal,
    BForm,
    BFormGroup,
    ValidationObserver,
    ValidationProvider,
    BFormInput,
    BFormInvalidFeedback,
  },
  methods: {
    ...mapActions(['changeWebinar']),
    changeWebinarTime() {
      let options = {
        ...this.form,
        id: this.webinar.id,
      }
      this.$bvModal
          .msgBoxConfirm('Пожалуйста, подтвердите, что вы хотите перенести вебинар', {
            title: 'Подтверждение',
            size: 'sm',
            okVariant: 'primary',
            okTitle: 'Да',
            cancelTitle: 'Нет',
            cancelVariant: 'outline-secondary',
            hideHeaderClose: false,
            centered: true,
          })
      .then(res => {
        if (res) {
          this.changeWebinar(options)
              .then(res => {
                this.$bvToast.toast('Вы успешно перенесли вебинар', {
                  title: `Вебинар перенесен! Удачи с уроком!`,
                  variant: 'success',
                  solid: true,
                })
              })
              .catch(err => {
                this.$bvToast.toast('Проблемы серверов', {
                  title: `Попробуйте, пожалуйста, позже`,
                  variant: 'danger',
                  solid: true,
                })
              })
        }
      })

    },
  },
  created() {
    this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
      if (modalId === 'editChangeTime') {
        this.$nextTick()
        .then(() => {
          this.form.scheduled_date = this.webinar.scheduled_date;
          this.form.scheduled_time = this.webinar.scheduled_time;
        })

      }
    })
  }
}
</script>

<style scoped>

</style>
